export default "<small *ngIf=\"errorMessage !== undefined\" class=\"errorMessage\" class=\"text-danger\">\r\n  {{ errorMessage }}\r\n</small>\r\n"